import React from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
//Todo: cleanup
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";

const useStyles = makeStyles((theme) => ({
	cancel: {
		color: theme.palette.custom.icon.red,
	},
	requestReview: {
		color: theme.palette.custom.icon.orange,
	},
	begin: {
		color: theme.palette.custom.icon.lightGreen,
	},
	submitClaim: {
		color: theme.palette.custom.icon.darkGreen,
	},
	button: {
		color: theme.palette.text.primary,
		borderColor: theme.palette.text.primary,
		maxWidth: "40px",
		maxHeight: "35px",
		minWidth: "40px",
		minHeight: "35px",
		marginTop: "5px",
		marginBottom: "5px",
	},
	buttonIcon: {
		color: theme.palette.text.primary,
	},
}));

const StyledMenu = styled(Menu)(({ theme }) => ({
	"& .MuiPaper-root": {
		border: `1px solid ${theme.palette.custom.creditRequest.menuBorder}`,
	},
}));

export default function CreditRequestList(props) {
	const { showCancel, showRequestReview, showBeginReview, showSubmitClaim, reason } = props;
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const onBeginReviewClick = () => {
		handleClose();
		props.onBeginReview(reason);
	};
	const onRequestReviewClick = () => {
		handleClose();
		props.onRequestReview(reason);
	};
	const onSubmitClaimClick = () => {
		handleClose();
		props.onSubmitClaim(reason);
	};
	const onCancelClick = () => {
		handleClose();
		props.onCancel();
	};

	return (
		<>
			<Button
				variant="outlined"
				className={classes.button}
				onClick={handleClick}
				sx={(theme) => ({
					...(theme.palette.mode === "dark" ? { borderColor: theme.palette.text.primary } : {}),
				})}
			>
				<MoreVertOutlinedIcon className={classes.buttonIcon} />
			</Button>
			<StyledMenu
				id="customized-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				elevation={0}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				{showBeginReview && (
					<MenuItem onClick={onBeginReviewClick}>
						<ListItemIcon>
							<VisibilityOutlinedIcon className={classes.begin} />
						</ListItemIcon>
						<ListItemText primary="Begin Review" />
					</MenuItem>
				)}
				{showRequestReview && (
					<MenuItem onClick={onRequestReviewClick}>
						<ListItemIcon>
							<CheckBoxOutlinedIcon className={classes.requestReview} />
						</ListItemIcon>
						<ListItemText primary="Request Review" />
					</MenuItem>
				)}
				{showSubmitClaim && (
					<MenuItem onClick={onSubmitClaimClick}>
						<ListItemIcon>
							<SaveOutlinedIcon className={classes.submitClaim} />
						</ListItemIcon>
						<ListItemText primary="Submit Claim" />
					</MenuItem>
				)}
				{showCancel && (
					<MenuItem onClick={onCancelClick}>
						<ListItemIcon>
							<CancelOutlinedIcon className={classes.cancel} />
						</ListItemIcon>
						<ListItemText primary="Cancel" />
					</MenuItem>
				)}
			</StyledMenu>
		</>
	);
}
CreditRequestList.propTypes = {
	onCancel: PropTypes.func.isRequired,
	onBeginReview: PropTypes.func.isRequired,
	onRequestReview: PropTypes.func,
	onSubmitClaim: PropTypes.func.isRequired,
	reason: PropTypes.string.isRequired,
	showCancel: PropTypes.bool,
	showRequestReview: PropTypes.bool,
	showBeginReview: PropTypes.bool,
	showSubmitClaim: PropTypes.bool,
};
